import { Components } from "formiojs";

const ROLE_VALUES = [
  { label: "System Administrator", value: "SYSTEM_ADMIN", shortcut: "" },
  { label: "Gemeinde Administrator", value: "COMMUNITY_ADMIN", shortcut: "" },
  { label: "Gemeinde Mitarbeiter", value: "COMMUNITY_MEMBER", shortcut: "" },
  { label: "Tester", value: "TESTER", shortcut: "" },
  { label: "Formular Ersteller", value: "FORM_BUILDER", shortcut: "" },
];

const DEFAULT_VISIBLE_FOR_ROLES = {};
const DEFAULT_EDITABLE_FOR_ROLES = {};

function getInvalidEditableRoles(visible, editable) {
  visible = visible || {};
  editable = editable || {};

  return Object.keys(editable).filter(function (role) {
    return editable[role] === true && visible[role] !== true;
  });
}

const ROLE_CONFLICT_VALIDATION = `
  const visible = data.visibleForRoles || {};
  const editable = data.editableForRoles || {};

  const visibleRoles = Object.keys(visible).filter(function(role) {
    return visible[role] === true;
  });

  const editableRoles = Object.keys(editable).filter(function(role) {
    return editable[role] === true;
  });

  if (visibleRoles.length === 0) {
    valid = "Bitte wählen Sie mindestens eine sichtbare Rolle aus.";
  } else if (editableRoles.length === 0) {
    valid = "Bitte wählen Sie mindestens eine bearbeitbare Rolle aus.";
  } else {
    const invalidRoles = editableRoles.filter(function(role) {
      return visible[role] !== true;
    });

    valid = invalidRoles.length === 0
      ? true
      : "Eine Rolle darf nur bearbeitbar sein, wenn sie auch sichtbar ist.";
  }
`;

const visibleForRolesField = {
  type: "selectboxes",
  input: true,
  key: "visibleForRoles",
  label: "Sichtbar für Rollen",
  tooltip: "Legt fest, welche OZG-Manager-Rollen diese Komponente sehen dürfen.",
  weight: 998,
  defaultValue: { ...DEFAULT_VISIBLE_FOR_ROLES },
  values: ROLE_VALUES,

  validate: {
   required: true,
   custom: ROLE_CONFLICT_VALIDATION,
  },

  logic: [
    {
      name: "Bearbeitbar korrigieren, wenn Sichtbar abgewählt wurde",
      trigger: {
        type: "javascript",
        javascript: `
          result = true;
        `,
      },
      actions: [
        {
          name: "Nicht sichtbare Rollen aus bearbeitbar entfernen",
          type: "customAction",
          customAction: `
            const visible = data.visibleForRoles || {};
            const editable = data.editableForRoles || {};

            Object.keys(editable).forEach(function(role) {
              if (editable[role] === true && visible[role] !== true) {
                editable[role] = false;
              }
            });

            data.editableForRoles = editable;
          `,
        },
      ],
    },
  ],
};

const editableForRolesField = {
  type: "selectboxes",
  input: true,
  key: "editableForRoles",
  label: "Bearbeitbar für Rollen",
  tooltip:
    "Legt fest, welche OZG-Manager-Rollen diese Komponente bearbeiten dürfen. Eine Rolle kann nur bearbeiten, wenn sie die Komponente auch sehen darf.",
  weight: 999,
  defaultValue: { ...DEFAULT_EDITABLE_FOR_ROLES },
  values: ROLE_VALUES,

  validate: {
   required: true,
   custom: ROLE_CONFLICT_VALIDATION,
  },

  logic: [
    {
      name: "Sichtbar automatisch setzen, wenn Bearbeitbar gewählt wurde",
      trigger: {
        type: "javascript",
        javascript: `
          result = true;
        `,
      },
      actions: [
        {
          name: "Bearbeitbare Rollen automatisch sichtbar setzen",
          type: "customAction",
          customAction: `
            const visible = data.visibleForRoles || {};
            const editable = data.editableForRoles || {};

            Object.keys(editable).forEach(function(role) {
              if (editable[role] === true) {
                visible[role] = true;
              }
            });

            data.visibleForRoles = visible;
          `,
        },
      ],
    },
  ],
};

function findDisplayPanel(editForm) {
  if (!editForm || !Array.isArray(editForm.components)) {
    return null;
  }

  const tabs = editForm.components.find((component) => component.key === "tabs");

  if (tabs && Array.isArray(tabs.components)) {
    return tabs.components.find((panel) => panel.key === "display");
  }

  return editForm.components?.[0]?.components?.find(
    (panel) => panel.key === "display"
  );
}

function extendComponentEditForm(componentType) {
  const Component = Components.components[componentType];

  if (!Component || !Component.editForm) {
    console.warn(
      "[FormioAllowedRolesExtension] Komponente nicht gefunden:",
      componentType
    );
    return;
  }

  if (Component.__allowedRolesExtended) {
    return;
  }

  const originalEditForm = Component.editForm;

  Component.editForm = function (...extend) {
    const editForm = originalEditForm.call(this, ...extend);

    const displayPanel = findDisplayPanel(editForm);

    if (displayPanel && Array.isArray(displayPanel.components)) {
      const hasVisibleForRoles = displayPanel.components.some(
        (component) => component.key === "visibleForRoles"
      );

      const hasEditableForRoles = displayPanel.components.some(
        (component) => component.key === "editableForRoles"
      );

      if (!hasVisibleForRoles) {
        displayPanel.components.push({ ...visibleForRolesField });
      }

      if (!hasEditableForRoles) {
        displayPanel.components.push({ ...editableForRolesField });
      }
    }

    return editForm;
  };

  Component.__allowedRolesExtended = true;
}

export function registerAllowedRolesExtension() {
  [
    "textfield",
    "textarea",
    "number",
    "email",
    "phoneNumber",
    "select",
    "checkbox",
    "radio",
    "selectboxes",
    "button",
    "panel",
    "columns",
    "container",
    "datagrid",
    "editgrid",
    "htmlelement",
    "content",
  ].forEach(extendComponentEditForm);
}